import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import i18n from 'i18next';
import { useSelector } from 'react-redux';
import { TablePagination } from '@material-ui/core';
import $ from 'jquery';
import DataTable from './ui/table';
import SearchBar from './ui/searchBar';
import RelatedCameraEdit from './terminalDashboard/relatedCamera-edit';
import RelatedCameraDetail from './terminalDashboard/relatedCamera-detail'; // api

import { getDeviceCameras } from '../api/deviceAPI';
import { getAreaTerminals } from '../api/areaAPI'; // redux

var t = i18n.getFixedT(null, 'terminal-dashboard');
var gt = i18n.getFixedT(null, 'app');
var TerminalDashboard = /*#__PURE__*/React.memo(function (props) {
  // redux
  var _useSelector = useSelector(function (state) {
    return state.toJS();
  }),
      rights = _useSelector.sessionObj.rights,
      contextRoot = _useSelector.envCfg.contextRoot;

  var id = props.id;

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      totalCount = _useState2[0],
      setTotalCount = _useState2[1];

  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      currentPage = _useState4[0],
      setCurrentPage = _useState4[1];

  var _useState5 = useState(25),
      _useState6 = _slicedToArray(_useState5, 2),
      rowsPerPage = _useState6[0],
      setRowsPerPage = _useState6[1];

  var _useState7 = useState(),
      _useState8 = _slicedToArray(_useState7, 2),
      keyword = _useState8[0],
      setKeyword = _useState8[1];

  var _useState9 = useState({}),
      _useState10 = _slicedToArray(_useState9, 2),
      tableData = _useState10[0],
      setTableData = _useState10[1];

  var _useState11 = useState({
    field: 'defaultOrder',
    desc: false
  }),
      _useState12 = _slicedToArray(_useState11, 2),
      tableSort = _useState12[0],
      setTableSort = _useState12[1];

  var _useState13 = useState(''),
      _useState14 = _slicedToArray(_useState13, 2),
      dialogMode = _useState14[0],
      setDialogMode = _useState14[1];

  var _useState15 = useState({}),
      _useState16 = _slicedToArray(_useState15, 2),
      dialogData = _useState16[0],
      setDialogData = _useState16[1];

  var _useState17 = useState([]),
      _useState18 = _slicedToArray(_useState17, 2),
      allCameraList = _useState18[0],
      setAllCameraList = _useState18[1];

  var handleChangeRowsPerPage = function handleChangeRowsPerPage(e) {
    setRowsPerPage(parseInt(e.target.value, 10));
    setCurrentPage(0);
  };

  var handleGetAreaTerminalsDeliverType = function handleGetAreaTerminalsDeliverType() {
    var offset = (Number(currentPage + 1) - 1) * rowsPerPage;
    getAreaTerminals(contextRoot, false, null, tableSort, offset, rowsPerPage, keyword, false).then(function (result) {
      if (result.totalElements !== totalCount) setTotalCount(result.totalElements);

      var newData = _.cloneDeep(result.content);

      _.map(newData, function (el, index) {
        el.sequence = offset + index + 1;
      });

      setTableData(newData);
    });
  };

  var handleDialogConfirm = function handleDialogConfirm() {
    handleGetAreaTerminalsDeliverType();
    setDialogData({});
  };

  var handleCloseDialog = function handleCloseDialog() {
    setDialogMode('');
    setDialogData({});
  };

  useEffect(function () {
    handleGetAreaTerminalsDeliverType();
  }, [keyword, JSON.stringify(tableSort), currentPage, rowsPerPage]);
  useEffect(function () {
    var sort = {
      field: 'name',
      desc: false
    };
    var getAnalyticCamera = getDeviceCameras(contextRoot, false, null, sort, 0, null, false, true, null);
    var getCCTV = getDeviceCameras(contextRoot, false, null, sort, 0, null, false, false);
    var getRoad = getDeviceCameras(contextRoot, false, null, sort, 0, null, true, false);
    $.when(getAnalyticCamera, getCCTV, getRoad).then(function (analyticCamera_result, cctv_result, road_result) {
      setAllCameraList([].concat(_toConsumableArray(analyticCamera_result.content), _toConsumableArray(cctv_result.content), _toConsumableArray(road_result.content)));
    });
  }, []);
  var fields = {};

  _.set(fields, 'sequence', {
    label: t('lbl-sequence')
  });

  _.set(fields, 'name', {
    label: t('lbl-terminal-types'),
    sortable: true
  }); // _.set(fields, 'deliverType', { label: t('lbl-container-deliver-types'), sortable: true,
  //     formatter: (val, row) => <div className='deliverType-div'>{val ? t('lbl-' + val.toUpperCase()) : ''}</div>
  // })


  _.set(fields, 'pickUpTrailerLineQty', {
    label: t('lbl-pickUp-vehicle-wait-count'),
    sortable: true,
    formatter: function formatter(val, row) {
      return /*#__PURE__*/React.createElement("div", {
        className: "lineQty-div"
      }, val === -1 ? t('lbl-no-data') : val);
    }
  });

  _.set(fields, 'pickUpEstLineDuration', {
    label: t('lbl-pickUp-forecast-wait-time'),
    sortable: true,
    formatter: function formatter(val, row) {
      return /*#__PURE__*/React.createElement("div", {
        className: "duration-div"
      }, val === -1 ? t('lbl-no-data') : val + t('lbl-minute'));
    }
  });

  _.set(fields, 'returnTrailerLineQty', {
    label: t('lbl-return-vehicle-wait-count'),
    sortable: true,
    formatter: function formatter(val, row) {
      return /*#__PURE__*/React.createElement("div", {
        className: "lineQty-div"
      }, val === -1 ? t('lbl-no-data') : val);
    }
  });

  _.set(fields, 'returnEstLineDuration', {
    label: t('lbl-return-forecast-wait-time'),
    sortable: true,
    formatter: function formatter(val, row) {
      return /*#__PURE__*/React.createElement("div", {
        className: "duration-div"
      }, val === -1 ? t('lbl-no-data') : val + t('lbl-minute'));
    }
  });

  _.set(fields, 'updatedAt', {
    label: t('lbl-update-time'),
    sortable: true
  }); // _.includes(rights, '')


  _.set(fields, 'more', {
    label: t('lbl-more'),
    formatter: function formatter(val, row) {
      return /*#__PURE__*/React.createElement("div", {
        className: "icon-block"
      }, _.includes(rights, 'evms.dashboard.terminal.camera') && /*#__PURE__*/React.createElement("a", {
        onClick: function onClick() {
          setDialogMode('edit');
          setDialogData(row);
        },
        title: t('lbl-edit')
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-pencil-alt"
      })), /*#__PURE__*/React.createElement("a", {
        onClick: function onClick() {
          setDialogMode('detail');
          setDialogData(row);
        },
        title: t('lbl-detail')
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-list-alt"
      })));
    }
  });

  return /*#__PURE__*/React.createElement("div", {
    id: id
  }, /*#__PURE__*/React.createElement("div", {
    className: "terminal-dashboard-table"
  }, /*#__PURE__*/React.createElement("div", {
    className: "table-head"
  }, /*#__PURE__*/React.createElement("span", {
    className: "title"
  }, t('lbl-terminal-station')), /*#__PURE__*/React.createElement("div", {
    className: "event-manage-headBar"
  }, /*#__PURE__*/React.createElement(SearchBar, {
    searchIconPosition: "right",
    placeholder: "Search",
    onSearch: function onSearch(search) {
      setKeyword(search); // if(_.isEmpty(search))
      //     handleGetAreaTerminalsDeliverType()
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "c-border c-position-rlt"
  }, /*#__PURE__*/React.createElement(DataTable, {
    fields: fields,
    data: tableData,
    sort: tableSort,
    onSort: function onSort(sort) {
      return setTableSort(sort);
    }
  })), /*#__PURE__*/React.createElement(TablePagination, {
    component: "div",
    labelRowsPerPage: gt('global.lbl-per-page-row-count'),
    count: totalCount,
    page: currentPage,
    onChangePage: function onChangePage(e, newPage) {
      return setCurrentPage(newPage);
    },
    rowsPerPage: rowsPerPage,
    onChangeRowsPerPage: handleChangeRowsPerPage
  })), !_.isEmpty(dialogMode) && dialogMode === 'edit' && /*#__PURE__*/React.createElement(RelatedCameraEdit, {
    allCameraList: allCameraList,
    dialogData: dialogData,
    onConfirm: function onConfirm() {
      return handleDialogConfirm();
    },
    onClose: function onClose() {
      return handleCloseDialog();
    }
  }), !_.isEmpty(dialogMode) && dialogMode === 'detail' && /*#__PURE__*/React.createElement(RelatedCameraDetail, {
    dialogData: dialogData,
    onClose: function onClose() {
      return handleCloseDialog();
    }
  }));
});
TerminalDashboard.defaultProps = {
  id: 'g-terminal-dashboard'
};
TerminalDashboard.PropTypes = {
  id: PropTypes.string
};
export default TerminalDashboard;